<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-13 14:56:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/securitycheck/components/CodeField/index.vue
-->
<template>
  <div class="code_phone">
    <van-field
      v-model="verifyCode"
      name="verifyCode"
      maxlength="6"
      type="number"
      center
      placeholder="请输入短信验证码"
      @input="verifyCodeChange"
    >
      <template #button>
        <div
          v-if="!showTime"
          class="code_get font12 font_weight400"
          @click="senderCode"
        >
          获取验证码
        </div>
        <div class="code_get font12 font_weight400">
          <van-count-down
            v-if="showTime"
            :time="time"
            format="ss秒后重发"
            @finish="finish"
          />
        </div>
      </template>
    </van-field>
  </div>
</template>
<script>
export default {
  data() {
    return {
      verifyCode: "",
      showTime: false,
      senderText: "发送验证码",
      time: 60000
    };
  },
  methods: {
    verifyCodeChange(value) {
      this.$emit("input", value);
    },
    senderCode() {
      this.showTime = true;
      this.$emit("senderCode");
    },
    finish() {
      this.senderText = "重新发送";
      this.showTime = false;
    }
  }
};
</script>
<style lang="less" scoped>
.code_phone {
  margin: 24px 12px 0;
}
::v-deep .van-cell {
  background: #f6f7f8;
  border-radius: 20px;
}
::v-deep .van-count-down {
  color: rgba(0, 0, 0, 0.38);
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}
.code_get {
  padding-left: 16px;
  border-left: 1px solid #d8d8d8;
  color: #d91818;
  line-height: 14px;
}
</style>
